import isUndefinedOrNull from '@ahd/shared/tools/is-undefined-or-null';
import { type NavigateFunction } from 'react-router';

import { isRouterEnvironment } from 'src/hooks/is-router-environment';

export default function enhancedNavigate(url: string, navigate?: NavigateFunction, replace?: boolean): void {
    if (isUndefinedOrNull(navigate)) {
        if (replace === true) {
            location.replace(url);
        } else {
            location.assign(url);
        }
    }
    if (isRouterEnvironment('next-js')) {
        // In Next.js: Browser History direkt manipulieren
        if (replace) {
            window.history.replaceState({}, '', url);
        } else {
            window.history.pushState({}, '', url);
        }

        // Memory Router nachziehen lassen
        navigate?.(url, { replace });

        // Next.js über URL-Änderung informieren (falls Next.js Router verfügbar)
        if ('next' in window && typeof (window as any).next?.router?.push === 'function') {
            const nextRouter = (window as any).next.router;
            if (replace) {
                nextRouter.replace(url, url, { shallow: true });
            } else {
                nextRouter.push(url, url, { shallow: true });
            }
        }
    } else {
        // Standalone: Normales React Router Verhalten
        navigate?.(url, { replace });
    }

    if (typeof window?._paq !== 'undefined') {
        window?._paq?.push(['setCustomUrl', url]);
        window?._paq?.push(['trackPageView']);
    }
}
